<template>
  <div ref="app" id="app">
    <keep-alive v-if="$route.meta.keepAlive">
      <router-view>
      </router-view>
    </keep-alive>
    <router-view v-else>
    </router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  created () {
    window.onmessage = function (e) {
      // 为了APP移动端在pc上套用iframe的时候需要返回按钮的时候通信
      if (event && event.data && typeof event.data === 'string' && event.data === 'edit') {
        let reply = JSON.stringify({url: window.location.href, type: 'edit'})
        window.parent.postMessage(
          reply, '*'
        )
      } else if (event && event.data && typeof event.data === 'string' && event.data === 'list') {
        let reply = JSON.stringify({url: window.location.href, type: 'list'})
        window.parent.postMessage(
          reply, '*'
        )
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss">
blockquote,
body,
button,
dd,
dl,
dt,
fieldset,
form,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
input,
legend,
li,
ol,
p,
pre,
td,
textarea,
th,
ul {
  margin: 0;
  padding: 0;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
}

address,
cite,
dfn,
em,
var {
  font-style: normal;
}

code,
kbd,
pre,
samp {
  font-family: courier new, courier, monospace;
}

small {
  font-size: 12px;
}

ol,
ul {
  list-style: none;
}

a {
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

sup {
  vertical-align: text-top;
}

sub {
  vertical-align: text-bottom;
}

legend {
  color: #000;
}

fieldset,
img {
  border: 0;
}

button,
input,
select,
textarea {
  font-size: 100%;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

#app {
  background-color: #fff;
  overflow: auto;
  height: 100%;
}

html,
body {
  height: 100%;
}

input {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-modify: read-write-plaintext-only;
}

input:focus,
textarea:focus {
  outline: none;
}

input::-ms-clear {
  display: none;
}

textarea {
  resize: none;
}

.list-component-item {
  .el-form-item.is-success .el-input__inner {
    border-color: #fff !important;
  }

  input,textarea {
    border: none !important;
    text-align: right;
    font-size: 15px !important;
    width: 100% !important;
    color: #121212 !important;
  }
  textarea {
    text-align:left;
  }
  input:disabled {
    opacity: 1 !important;
  }
}
/* 移动端表单元素左边距跟下外边距取消*/
.el-form-item {
  margin-bottom: 0 !important;
}
.el-form-item__content {
  margin-left: 0 !important;
}
.list-component-item {
  background-color: #ffffff;
  position: relative;
  .el-form-item__content {
    // 修复表格必填样式错乱 有影响再撤回
    /*position: static !important;*/
  }
  .el-form-item__error {
    height: 15px;
    position: absolute;
    z-index: 1;
    left: 3.6vw;
    top: calc(13.16vw - 17px);
  }
}
/*移动端图片src为空时清除边框*/
.unrequired {
  opacity: 0 !important;
}
.required-flag{
  font-size: 14px;
  color: rgb(245, 108, 108);
  margin-right: 4px;
}
.el-message {
  min-width: 60vw;
  max-width: 80vw;
}
/* 滚动条统一样式 */
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  background-color: transparent;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: transparent;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #e2e2e2;
}

/*滑块效果*/
::-webkit-scrollbar-thumb:hover {

  border-radius: 5px;
  background: #c8c8c8;
}
.has-background {
  ::-webkit-scrollbar-thumb{
    background-color: #c8c8c8;
  }
}
#app {
  min-height: 380px;
  font-family: "PingFang SC","Helvetica Neue",Helvetica,"Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #181818;

  .tooltip {
    color: #c2c3c4;

    &:hover {
      color: #409EFF;
    }
  }

  /*IE滚动条颜色*/
  scrollbar-face-color: #c8c8c8;
  /*滚动条颜色*/
  scrollbar-highlight-color: #fff;
  scrollbar-3dlight-color: #fff;
  scrollbar-darkshadow-color: #c8c8c8;
  scrollbar-shadow-color: #fff;
  /*滑块边色*/
  scrollbar-arrow-color: #c8c8c8;
  /*箭头颜色*/
  scrollbar-track-color: #fff;
  .el-input.is-disabled .el-input__inner {
    cursor: pointer;
  }
}
/* 去除阴影 */
.del-shadow {
  -webkit-tap-highlight-color: transparent;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  tap-highlight-color: rgba(0, 0, 0, 0);
}
</style>



// WEBPACK FOOTER //
// src/App.vue